import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ProductCard from "../components/ProductCard"; // ✅ Correct path

function Products() {
  const [products, setProducts] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const fetchProducts = async () => {
      let url = "http://kolibusiness.com/backend/api-products.php";

      const params = new URLSearchParams(location.search);
      const search = params.get("search");
      const subcategory = params.get("subcategory");

      if (search) {
        url += `?search=${encodeURIComponent(search)}`;
      } else if (subcategory) {
        url += `?subcategory=${encodeURIComponent(subcategory)}`;
      }

      const res = await fetch(url);
      const data = await res.json();
      setProducts(data);
    };

    fetchProducts();
  }, [location.search]);

  return (
    <div style={{ padding: "20px" }}>
      <h2>All Products</h2>
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        justifyContent: "flex-start"
      }}>
        {products.length === 0 ? (
          <p>No products found.</p>
        ) : (
          products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))
        )}
      </div>
    </div>
  );
}

export default Products;
